import React from 'react';
import { StaticPageWithData } from '../components/StaticPage';
import PageMeta from '../components/PageMeta';

/**
 * Página de Política de Privacidad
 * 
 * Esta página consume datos dinámicos de la API backend a través del componente
 * StaticPageWithData, garantizando contenido siempre actualizado.
 * 
 * Funcionalidades incluidas:
 * - Carga dinámica de contenido vía API
 * - Manejo de errores robusto con opción de reintentar
 * - Estados de carga visual
 * - SEO optimizado con meta tags dinámicas
 * - Breadcrumbs para navegación
 * - Diseño responsivo
 * - Accesibilidad (ARIA labels)
 */
const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-page">
      <PageMeta
        title="Política de Privacidad - Café Tutoriales"
        description="Conozca nuestra política de privacidad y cómo protegemos sus datos personales en la plataforma Café Tutoriales."
        keywords="política privacidad, datos personales, protección datos, cafe, tutorial"
        canonical="https://cafetutoriales.com/politica-privacidad"
      />
      <StaticPageWithData
        pageType="privacy"
      />
    </div>
  );
};

export default PrivacyPolicy;